<template>
     <Breadcrumbs main="Ecommerce" title="Recent Orders" />
     <div class="container-fluid">
          <div class="row">
               <newOrder />
               <orderTable />
          </div>
     </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const orderTable = defineAsyncComponent(() => import("@/components/theme/ecommerce/order/orderTable.vue"))
const newOrder = defineAsyncComponent(() => import("@/components/theme/ecommerce/order/newOrder.vue"))
</script>